<template>
  <div
    v-if="showCall && enableCall"
    class="direct-call"
    :class="{ expand: expand }"
  >
    <div v-if="expand" class="box">
      <div class="col">
        <div class="row on">
          <div class="row">
            <img src="../../../assets/img-v2/ic_on.png" class="icon" />
            <div class="label">{{ onStopName }}</div>
          </div>
          <div class="close" @click="onToggle">收起</div>
        </div>
        <div class="row">
          <img src="../../../assets/img-v2/ic_off.png" class="icon" />
          <div class="label">{{ offStopName }}</div>
        </div>
      </div>

      <div class="row bottom">
        <div v-if="isHaveOther" class="btn other" @click="onGoList">
          换一个
        </div>
        <div class="btn call" @click="onCall">一键呼叫</div>
      </div>
    </div>
    <div v-else class="circle" @click="onToggle">一键<br />呼叫</div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { startOrder, showToast } from "@/views/direct-call/service";

export default {
  name: "DirectCallEntry",
  model: {
    prop: "expand",
    event: "toggle",
  },
  props: {
    expand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ordering: false,
    };
  },
  computed: {
    ...mapGetters({
      callInfo: "config/callInfo",
      showCall: "config/showCall",
      enableCall: "config/enableCall",
    }),
    onStopName() {
      const { onName } = this.callInfo || {};
      return onName || "";
    },
    offStopName() {
      const { offName } = this.callInfo || {};
      return offName || "";
    },
    isHaveOther() {
      const { haveOther } = this.callInfo || {};
      return haveOther === 1 || true;
    },
  },
  watch: {
    callInfo(info) {
      const { id } = info || {};
      this.setShowCall(!!id);
    },
    ordering(val) {
      showToast("下单中，请稍候", val, this);
    },
  },
  methods: {
    ...mapMutations({
      setShowCall: "config/setShowCall",
    }),
    onToggle() {
      this.$emit("toggle", !this.expand);
    },
    onGoList() {
      const { baseLineId, lineName } = this.callInfo || {};
      this.$router.push({
        name: "directCallList",
        query: {
          baseLineId,
          lineName,
        },
      });
    },
    onCall() {
      if (this.ordering) return;
      const { baseLineId, onId, onName, offId, offName } = this.callInfo;

      this.ordering = true;
      startOrder(
        {
          baseLineId,
          onStopId: onId,
          onStopName: onName,
          offStopId: offId,
          offStopName: offName,
        },
        this
      )
        .then(() => {
          this.setShowCall(false);
          setTimeout(() => {
            this.$OrderService.turnToOrderPay(
              { from: "Home" },
              { ticketInfoId: this.$AppService.getTicketInfoId() }
            );
          }, 500);
        })
        .catch((res) => {
          const { msg } = res || {};
          setTimeout(() => {
            this.$cheToast({
              type: "fail",
              text: msg || "",
              timeout: 3000,
            });
          }, 100);
        })
        .finally(() => {
          this.ordering = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.direct-call {
  display: inline-block;
  .expand {
    display: block;
  }
  .box {
    width: calc(100vw - 20px);
    background: linear-gradient(135deg, #cae4ff 0%, #e8f6ff 100%);
    border-radius: 28px;
    border: 2px solid #ffffff;
    padding: 16px;
    position: relative;
  }

  .col {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
  }

  .row {
    display: flex;
    align-items: center;
  }

  .bottom {
    margin-top: 8px;
  }

  .on {
    padding-bottom: 8px;
    justify-content: space-between;
  }

  .label {
    width: 100%;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .icon {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }

  .close {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 17px;
    text-align: right;
    font-style: normal;
  }

  .btn {
    flex: 1;
    height: 32px;
    border-radius: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
    font-style: normal;
  }

  .call {
    color: #ffffff;
    background: linear-gradient(90deg, #00a7fd 0%, #006efa 100%);
    margin-left: 8px;
  }
  .other {
    color: #686868;
    background: #ffffff;
  }

  .circle {
    width: 60px;
    height: 60px;
    background: linear-gradient(90deg, #00a7fd 0%, #006efa 100%);
    box-shadow: 0px 0px 6px 0px #7196c2;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #ffffff;
    line-height: 16px;
    text-align: left;
    font-style: normal;
  }
}
</style>
